module.exports = __webpack_public_path__ + "img/icon-step.b6ec467d.svg";